import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#4173CD"
  }} d="M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621V256h512V126.621  C512,105.443,494.833,88.276,473.655,88.276z" /><path style={{
    fill: "#FF4B55"
  }} d="M0,385.379c0,21.174,17.162,38.339,38.334,38.345h435.332C494.838,423.719,512,406.553,512,385.379  V256H0V385.379z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };